// Utilidades para manejo de fechas y horarios
export const AVAILABLE_HOURS = [
  '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
  '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00'
];

// Horarios para sábados (10:00 a 14:00)
export const SATURDAY_HOURS = [
  '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00'
];

// Obtener horarios disponibles según el día de la semana
export const getAvailableHoursForDate = (date) => {
  let dayOfWeek;
  
  // Si es una cadena en formato YYYY-MM-DD, la parseamos correctamente
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);
    dayOfWeek = dateObj.getDay();
  } else {
    dayOfWeek = new Date(date).getDay();
  }
  
  console.log('🔍 Debug getAvailableHoursForDate:', {
    date: date,
    dateType: typeof date,
    dayOfWeek: dayOfWeek,
    dayName: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][dayOfWeek]
  });
  
  if (dayOfWeek === 0) { // Domingo - no hay horarios disponibles
    console.log('❌ Domingo detectado - no hay horarios');
    return [];
  }
  
  if (dayOfWeek === 6) { // Sábado - horarios reducidos
    console.log('📅 Sábado detectado - horarios reducidos:', SATURDAY_HOURS);
    return SATURDAY_HOURS;
  }
  
  console.log('✅ Día de semana detectado - horarios completos:', AVAILABLE_HOURS);
  return AVAILABLE_HOURS; // Lunes a viernes - horarios completos
};

// Formatear fecha para mostrar
export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('es-CL', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Formatear fecha para API (YYYY-MM-DD)
export const formatDateForAPI = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toISOString().split('T')[0];
};

// Formatear fecha para uso local (YYYY-MM-DD) - sin conversión UTC
export const formatDateForLocal = (date) => {
  if (!date) return '';
  
  // Si es una cadena de fecha, la parseamos correctamente
  if (typeof date === 'string') {
    // Si ya está en formato YYYY-MM-DD, la retornamos tal como está
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    // Si es otra cadena, la convertimos
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  // Si es un objeto Date
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Verificar si una fecha es hoy
export const isToday = (date) => {
  const today = new Date();
  const checkDate = new Date(date);
  return today.toDateString() === checkDate.toDateString();
};

// Verificar si una fecha es seleccionada
export const isSelected = (date, selectedDate) => {
  if (!date || !selectedDate) return false;
  
  // Si selectedDate es una cadena (YYYY-MM-DD), la convertimos a objeto Date
  const selectedDateObj = typeof selectedDate === 'string' 
    ? new Date(selectedDate + 'T00:00:00') 
    : new Date(selectedDate);
  
  const dateObj = new Date(date);
  
  // Comparar solo año, mes y día
  return dateObj.getFullYear() === selectedDateObj.getFullYear() &&
         dateObj.getMonth() === selectedDateObj.getMonth() &&
         dateObj.getDate() === selectedDateObj.getDate();
};

// Obtener horarios ocupados para una fecha específica
export const getOccupiedTimes = (citas, fecha) => {
  if (!citas || !fecha) return [];
  return citas
    .filter(cita => cita.fecha === fecha)
    .map(cita => cita.hora)
    .filter(hora => hora); // Filtrar valores nulos o undefined
};

// Validar si un horario está disponible
export const isTimeAvailable = (time, occupiedTimes) => {
  return !occupiedTimes.includes(time);
};

// Obtener horarios disponibles
export const getAvailableTimes = (occupiedTimes, date = null) => {
  const availableHours = date ? getAvailableHoursForDate(date) : AVAILABLE_HOURS;
  return availableHours.filter(time => isTimeAvailable(time, occupiedTimes));
};

// Obtener fechas de una semana
export const getWeekDates = (date) => {
  const week = [];
  const startOfWeek = new Date(date);
  
  // Ajustar para que el lunes sea el primer día de la semana
  const dayOfWeek = startOfWeek.getDay();
  const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // 0 = domingo, 1 = lunes, etc.
  startOfWeek.setDate(startOfWeek.getDate() - daysToSubtract);
  
  console.log('🔍 getWeekDates Debug:', {
    inputDate: date,
    startOfWeek: startOfWeek,
    dayOfWeek: dayOfWeek,
    daysToSubtract: daysToSubtract
  });
  
  for (let i = 0; i < 7; i++) {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + i);
    day.setHours(0, 0, 0, 0); // Establecer a medianoche para evitar problemas de zona horaria
    week.push(day);
  }
  
  console.log('📅 Generated week dates:', week.map(d => d.toISOString().split('T')[0]));
  
  return week;
};

// Validar formato de fecha
export const isValidDate = (dateString) => {
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date);
};

// Obtener hora actual en formato HH:MM
export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
};

// Verificar si una hora es en el futuro
export const isTimeInFuture = (date, time) => {
  const now = new Date();
  const appointmentDate = new Date(`${date}T${time}`);
  return appointmentDate > now;
};

// Obtener el próximo horario disponible
export const getNextAvailableTime = (occupiedTimes) => {
  const now = new Date();
  const currentTime = getCurrentTime();
  
  return AVAILABLE_HOURS.find(time => 
    !occupiedTimes.includes(time) && time > currentTime
  ) || AVAILABLE_HOURS[0];
}; 

// Formatear fecha para mostrar (con manejo correcto de cadenas)
export const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  
  // Si es una cadena en formato YYYY-MM-DD, la parseamos correctamente
  if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('es-ES', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
  }
  
  // Para otros formatos, usar el método estándar
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
}; 

// Función de prueba para verificar la lógica de días
export const testDayLogic = () => {
  console.log('🧪 Testing day logic...');
  
  // Verificar el año actual
  const currentYear = new Date().getFullYear();
  console.log('📅 Current year:', currentYear);
  
  // Probar sábado (2024-08-03 es un sábado)
  const saturdayTest = getAvailableHoursForDate('2024-08-03');
  console.log('Sábado test:', saturdayTest);
  
  // Probar domingo (2024-08-04 es un domingo)
  const sundayTest = getAvailableHoursForDate('2024-08-04');
  console.log('Domingo test:', sundayTest);
  
  // Probar lunes (2024-08-05 es un lunes)
  const mondayTest = getAvailableHoursForDate('2024-08-05');
  console.log('Lunes test:', mondayTest);
  
  // Probar las fechas específicas de las imágenes
  console.log('🧪 Testing specific dates from images...');
  
  // Sábado 2 de agosto de 2024
  const saturdayAug2 = getAvailableHoursForDate('2024-08-02');
  console.log('Sábado 2 de agosto:', saturdayAug2);
  
  // Domingo 3 de agosto de 2024
  const sundayAug3 = getAvailableHoursForDate('2024-08-03');
  console.log('Domingo 3 de agosto:', sundayAug3);
  
  // Verificar qué día de la semana es el 2 de agosto de 2024
  const testDate = new Date(2024, 7, 2); // Agosto es mes 7 (0-indexed)
  console.log('🔍 Test date 2024-08-02:', {
    date: testDate,
    dayOfWeek: testDate.getDay(),
    dayName: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][testDate.getDay()]
  });
  
  // Verificar qué día de la semana es el 2 de agosto del año actual
  const testDateCurrentYear = new Date(currentYear, 7, 2);
  console.log(`🔍 Test date ${currentYear}-08-02:`, {
    date: testDateCurrentYear,
    dayOfWeek: testDateCurrentYear.getDay(),
    dayName: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][testDateCurrentYear.getDay()]
  });
}; 